<template>
  <div>
    <div class="m_flex_row" style="margin-left:20px;margin-top:30px;margin-bottom:30px;">
      <h3 class="m_flex_column" style="width:150px;margin-right:20px">其它知情信息:</h3>
      <a-button class="editable-add-btn" @click="addOtherInfo" v-if="!onlyShow">新增一条</a-button>
    </div>
    <a-table
      style="margin:30px;"
      :columns="columns"
      :dataSource="otherInfoDataList"
      bordered
      :pagination="false"
    >
      <template slot="operation" slot-scope="text, record" v-if="!onlyShow">
        <a @click="() => otherInfoEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗?" @confirm="() => otherInfoDelete(record)">
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <a-modal v-model="addOtherInfoVisible" title="增加一条其他信息" @ok="addOk">
      <div class="m_flex_row" style="margin-left:0px;margin-top:10px;">
        <div class="m_flex_column" style="width:150px;">标题:</div>
        <a-input v-model="title" placeholder="请输入" allowClear style="width:500px" />
      </div>

      <!-- <div class="m_flex_row" style="margin-left:0px;margin-top:20px;">
        <div class="m_flex_column" style="width:110px;">患者必知:</div>
        <a-radio-group buttonStyle="solid" v-model="need_read" tyle="width:500px">
          <a-radio-button value="1">必知</a-radio-button>
          <a-radio-button value="0">不必知</a-radio-button>
        </a-radio-group>
      </div>-->

      <div class="m_flex_row" style="margin-left:0px;margin-top:20px;">
        <div class="m_flex_column" style="width:150px;">介绍:</div>
        <a-textarea
          v-model="introduce"
          placeholder="请输入"
          allowClear
          style="width:500px"
          :autosize="{ minRows: 6, maxRows: 20 }"
        />
      </div>

      <div class="m_flex_row" style="margin-left:0px;margin-top:20px;">
        <div class="m_flex_column" style="width:150px;">附件:</div>
        <a-upload
          :data="file_data"
          style="width:500px"
          name="file"
          :multiple="true"
          :file-list="fileList"
          :action="uploadURL+1"
          :withCredentials="withCredentials"
          :headers="headers"
          @change="handleChange"
        >
          <a-button>
            <a-icon type="upload" />点击上传
          </a-button>
        </a-upload>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Global from "@/global_variable";
import request from "@/utils/request";

export default {
  name: "ProjectAddShow",
  props: {
    otherInfoDataList: Array,
    onlyShow: Boolean
  },
  data() {
    const columns = [
      {
        title: "序号",
        dataIndex: "the_id",
        width: "5%"
      },
      {
        title: "标题",
        dataIndex: "title",
        width: "25%"
      },
      {
        title: "介绍",
        dataIndex: "introduce",
        width: "25%"
      },
      // {
      //   title: "是否必读",
      //   dataIndex: "need_read",
      //   width: "8%",
      //   customRender: (text, row, index) => {
      //     if (text === "1") {
      //       return "必读";
      //     } else {
      //       return "不必读";
      //     }
      //   }
      // },
      {
        title: "附件",
        dataIndex: "files_text",
        width: "20%"
      }
    ];
    if (!this.onlyShow) {
      columns.push({
        title: "操作",
        width: "30%",
        dataIndex: "operation",
        scopedSlots: { customRender: "operation" }
      });
    }
    console.log("columns", columns);
    return {
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
      uploadURL: Global.uploadURL,
      fileList: [],
      title: "",
      introduce: "",
      need_read: "1",
      file_data: {
        authority: 500
      },
      columns,
      addOtherInfoVisible: false,
      //上传请求时是否携带 cookie
      withCredentials: true
    };
  },
  methods: {
    handleChange(info) {
      let fileList = [...info.fileList];
      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      // fileList = fileList.slice(-2);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
    },
    addOtherInfo() {
      this.addOtherInfoVisible = true;
      this.current_the_id = -1;
    },
    otherInfoEdit(record) {
      console.log("点击编辑了", record);
      this.title = record["title"];
      this.current_the_id = record["the_id"];
      this.introduce = record["introduce"];
      this.need_read = record["need_read"];
      let i = 0;
      this.fileList = record["annexs"].map(item => {
        i += 1;
        return {
          uid: i,
          name: item.name,
          status: "done",
          url: item.url,
          response: item
        };
      });
      this.addOtherInfoVisible = true;
    },
    addOk() {
      for (let i = 0; i < this.fileList.length; i++) {
        let file = this.fileList[i];
        if (file.status !== "done") {
          this.$message.error("请等待附件上传完成再点击确定");
          return;
        }
      }
      if (this.title.length < 1 && this.introduce.length < 1) {
        this.$message.error("请输入标题");
        return;
      }
      console.log(
        "看看this.current_the_id",
        this.current_the_id,
        this.otherInfoDataList
      );
      let ole_otherInfoDataList = this.otherInfoDataList;
      if (ole_otherInfoDataList == undefined) {
        ole_otherInfoDataList = [];
      }
      if (this.current_the_id !== -1) {
        let otherInfoDataList = ole_otherInfoDataList.map(item => {
          if (item.the_id === this.current_the_id) {
            item.title = this.title;
            item.need_read = this.need_read;
            item.introduce = this.introduce;
            item.annexs = this.fileList.map(item => {
              return item.response;
            });

            if (item["annexs"]) {
              item["files_text"] = item["annexs"].map(file => {
                return file.name + "  ";
              });
            } else {
              item["files_text"] = "";
            }
          }
          return item;
        });
        this.addOtherInfoVisible = false;
        this.title = "";
        this.introduce = "";
        this.fileList = [];
        this.need_read = "1";
        // this.otherInfoDataList = otherInfoDataList;
        this.$emit("updateOtherInforDataList", otherInfoDataList);
      } else {
        let otherInfoDataList = ole_otherInfoDataList;
        otherInfoDataList.push({
          title: this.title,
          need_read: this.need_read,
          introduce: this.introduce,
          annexs: this.fileList.map(item => {
            return item.response;
          })
        });
        let i = 1;
        otherInfoDataList = otherInfoDataList.map(item => {
          item["the_id"] = i;
          if (item["annexs"]) {
            item["files_text"] = item["annexs"].map(file => {
              return file.name + "  ";
            });
          } else {
            item["files_text"] = "";
          }

          i += 1;
          return item;
        });
        this.addOtherInfoVisible = false;
        this.title = "";
        this.introduce = "";
        this.fileList = [];
        this.need_read = "1";
        this.otherInfoDataList = otherInfoDataList;
        this.$emit("updateOtherInforDataList", otherInfoDataList);
      }
    }
  }
};
</script>

<style>
</style>